// product-data.ts (or inside your component/service)
export const SHOPIFY_PRODUCTS = [
    {
      id: 15456723632431,
      admin_graphql_api_id: "gid://shopify/LineItem/15456723632431",
      attributed_staffs: [],
      current_quantity: 1,
      fulfillable_quantity: 1,
      fulfillment_service: "manual",
      fulfillment_status: null,
      gift_card: false,
      grams: 0,
      name: "Guía para elección de Universidad y plan de estudios - guia1",
      price: "89.00",
      price_set: {
        shop_money: { amount: "89.00", currency_code: "USD" },
        presentment_money: { amount: "89.00", currency_code: "USD" }
      },
      product_exists: true,
      product_id: 9912348246319,
      properties: [],
      quantity: 1,
      requires_shipping: false,
      sku: "VOYJALEASGUIDEUNI1",
      taxable: false,
      title: "Guía para elección de Universidad y plan de estudios",
      total_discount: "0.00",
      total_discount_set: {
        shop_money: { amount: "0.00", currency_code: "USD" },
        presentment_money: { amount: "0.00", currency_code: "USD" }
      },
      variant_id: 50984522219823,
      variant_inventory_management: null,
      variant_title: "guia1",
      vendor: "VoyJaleas",
      tax_lines: [],
      duties: [],
      discount_allocations: []
    },
    // CONTRATAR SEGURO MEDICO
    {
      id: 222,
      admin_graphql_api_id: "gid://shopify/LineItem/15456723632431",
      attributed_staffs: [],
      current_quantity: 1,
      fulfillable_quantity: 1,
      fulfillment_service: "manual",
      fulfillment_status: null,
      gift_card: false,
      grams: 0,
      name: "Contratar seguro médico ASISA-VoyJaleas",
      price: "55.00",
      price_set: {
        shop_money: { amount: "55.00", currency_code: "USD" },
        presentment_money: { amount: "55.00", currency_code: "USD" }
      },
      product_exists: true,
      product_id: 9912348246319,
      properties: [],
      quantity: 1,
      requires_shipping: false,
      sku: "VOYJALEASSEGURO",
      taxable: false,
      title: "Contratar seguro médico ASISA-VoyJaleas",
      total_discount: "0.00",
      total_discount_set: {
        shop_money: { amount: "0.00", currency_code: "USD" },
        presentment_money: { amount: "0.00", currency_code: "USD" }
      },
      variant_id: 51051369300271,
      variant_inventory_management: null,
      variant_title: "contratar-seguro-medico",
      vendor: "VoyJaleas",
      tax_lines: [],
      duties: [],
      discount_allocations: []
    },
    // GUIA PDF - Alojamiento
    {
      id: 231,
      admin_graphql_api_id: "gid://shopify/LineItem/51262754849071",
      attributed_staffs: [],
      current_quantity: 1,
      fulfillable_quantity: 1,
      fulfillment_service: "manual",
      fulfillment_status: null,
      gift_card: false,
      grams: 0,
      name: "Guia PDF Alojamiento",
      price: "9.099",
      price_set: {
        shop_money: { amount: "55.00", currency_code: "USD" },
        presentment_money: { amount: "55.00", currency_code: "USD" }
      },
      product_exists: true,
      product_id: 9912348246319,
      properties: [],
      quantity: 1,
      requires_shipping: false,
      sku: "VOYJALEASSEGURO",
      taxable: false,
      title: "Guia PDF Alojamiento",
      total_discount: "0.00",
      total_discount_set: {
        shop_money: { amount: "0.00", currency_code: "USD" },
        presentment_money: { amount: "0.00", currency_code: "USD" }
      },
      variant_id: 51262754849071,
      variant_inventory_management: null,
      variant_title: "contratar-seguro-medico",
      vendor: "VoyJaleas",
      tax_lines: [],
      duties: [],
      discount_allocations: []
    },
    // GUIA PDF - Alojamiento
    {
      id: 231,
      admin_graphql_api_id: "gid://shopify/LineItem/51262754849071",
      attributed_staffs: [],
      current_quantity: 1,
      fulfillable_quantity: 1,
      fulfillment_service: "manual",
      fulfillment_status: null,
      gift_card: false,
      grams: 0,
      name: "Videollamada 60 minutos",
      price: "9.099",
      price_set: {
        shop_money: { amount: "55.00", currency_code: "USD" },
        presentment_money: { amount: "55.00", currency_code: "USD" }
      },
      product_exists: true,
      product_id: 9912348246319,
      properties: [],
      quantity: 1,
      requires_shipping: false,
      sku: "VOYJALEASVID60",
      taxable: false,
      title: "Guia PDF Alojamiento",
      total_discount: "0.00",
      total_discount_set: {
        shop_money: { amount: "0.00", currency_code: "USD" },
        presentment_money: { amount: "0.00", currency_code: "USD" }
      },
      variant_id: 51822399947055,
      variant_inventory_management: null,
      variant_title: "contratar-seguro-medico",
      vendor: "VoyJaleas",
      tax_lines: [],
      duties: [],
      discount_allocations: []
    }
  ];
